





















import { Component, Vue, Prop } from 'vue-property-decorator'
import { ICustomerLeadLightModel, LeadFeedbackStatus } from '@immosparrow/cockpit-api-v2'

@Component
export default class LeadActions extends Vue {
  @Prop()
  lead!: ICustomerLeadLightModel;

  get statusLiked () {
    return this.lead?.customerEvaluation?.evaluation === LeadFeedbackStatus.Like
  }

  get statusDisliked () {
    return this.lead?.customerEvaluation?.evaluation === LeadFeedbackStatus.Dislike
  }

  get contactInfo () {
    return this.$store.getters.contactInfo
  }

  setFeedback (like: boolean) {
    this.$store.commit('setFeedbackData', { lead: this.lead, status: like })
  }
}
